"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelsService = void 0;
class LabelsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Returns all labels.
     * @returns LabelBasicResponse
     * @throws ApiError
     */
    getAllLabels() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/lables/',
        });
    }
    /**
     * Returns all values for a specific labelId.
     * @param id label uuid
     * @returns LabelValueResponse
     * @throws ApiError
     */
    getValuesForLabelId(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/lables/{id}/values',
            path: {
                'id': id,
            },
        });
    }
}
exports.LabelsService = LabelsService;
